import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"
import { hapticLight } from "@/utils/haptics"

const Switch = React.forwardRef(({ className, onCheckedChange, ...props }, ref) => {
  // Wrap onCheckedChange to add haptic feedback
  const handleCheckedChange = React.useCallback((checked) => {
    hapticLight(); // Light haptic on toggle
    if (onCheckedChange) {
      onCheckedChange(checked);
    }
  }, [onCheckedChange]);

  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-600 data-[state=unchecked]:bg-gray-300",
        className
      )}
      onCheckedChange={handleCheckedChange}
      {...props}
      ref={ref}>
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm transition-transform data-[state=checked]:translate-x-[22px] data-[state=unchecked]:translate-x-0.5"
        )} />
    </SwitchPrimitives.Root>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
